<template>
    <div class="center-column">
        <ArticleHeader 
        title="Sparse dictionary learning recovers pleiotropy from human cell fitness screens"
        dateUpdated="August 9, 2021"
        />
        <Authors />
        <AbstractText />
    </div>
</template>

<script>
import AbstractText from '../components/AbstractText.vue'
import ArticleHeader from '../components/ArticleHeader.vue'
import Authors from '../components/Authors.vue'

export default {
  name: 'HomePage',
  components: {
    AbstractText,
    ArticleHeader,
    Authors
  }
}
</script>

<style scoped>
    .navbar {
        display: inline;
        border-bottom: solid 1px gray;
        padding-bottom: 10px;
        margin-top: 20px
    }

    .nav-item {
        padding: 20px;
    }
</style>
